import React from 'react';
import styled from 'styled-components';
import { tombac } from '../../shared';
import { propStyling } from '../../shared/propStyling';
import { ButtonLegacy } from './ButtonLegacy';
import { ButtonGroupContext } from './ButtonGroupContext';
export const ButtonGroup = styled.div.attrs(_ref => {
  var _ref2, _theme$settings;
  let {
    children,
    size,
    theme
  } = _ref;
  return {
    children: /*#__PURE__*/React.createElement(ButtonGroupContext.Provider, {
      value: {
        size: (_ref2 = size !== null && size !== void 0 ? size : (_theme$settings = theme.settings) === null || _theme$settings === void 0 ? void 0 : _theme$settings.buttonSize) !== null && _ref2 !== void 0 ? _ref2 : 'm'
      }
    }, children),
    className: 'TombacButtonGroup'
  };
}).withConfig({
  displayName: "ButtonGroup"
})(["all:initial;border-radius:", ";display:inline-flex;", "{border-radius:0;}", ":focus,", ":focus-visible{border-radius:", ";}", ":not(:focus-visible){border-radius:0;}", ".TombacButton--variant-ghost{border-color:", ";}", ".TombacButton--variant-ghost + ", ".TombacButton--variant-ghost{margin-left:", ";}", ""], tombac.unit(1), ButtonLegacy, ButtonLegacy, ButtonLegacy, tombac.unit(1), ButtonLegacy, ButtonLegacy, tombac.color('neutral', 400), ButtonLegacy, ButtonLegacy, tombac.unit(-1), propStyling);
//# sourceMappingURL=ButtonGroup.js.map